module.exports = __webpack_public_path__ + "static/media/folder-green.3e63d99a.svg";